import React from "react";
import { MODAL_STYLES } from "../../constants/modal-styles";

interface ModalButtonProps {
  onClick: () => void;
  disabled?: boolean;
  variant?: "primary" | "secondary";
  fullWidth?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const ModalButton = ({
  onClick,
  disabled = false,
  variant = "primary",
  fullWidth = true,
  children,
  className = "",
}: ModalButtonProps) => {
  const baseStyle =
    variant === "primary"
      ? fullWidth
        ? MODAL_STYLES.buttonFull
        : MODAL_STYLES.button
      : fullWidth
        ? MODAL_STYLES.buttonSecondary
        : MODAL_STYLES.button;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyle} ${disabled ? "disabled:cursor-not-allowed disabled:opacity-50" : ""} ${className}`}
    >
      {children}
    </button>
  );
};
